module.exports = __webpack_public_path__ + "img/manage.f90e50f6.png";